<template>
  <div class="not-join">
    <!-- <div class="join-top">
      <div class="join-top-left">
        <span class="join-top-left-icon">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-a-warring-tianchong3"></use>
          </svg>
        </span>

        <span class="join-top-left-text">You are not a member of this campaign</span>
      </div>
      <artmisads-button :isSquare="true" type="primary" class="join-top-right" @click="joinCampaign">Join
        Campaign</artmisads-button>
    </div> -->
    <div class="join-content">
      <CampaignInfoCard :item="item" />
    </div>

    <div class="join-table">
      <artmisads-segmented-tabs
              v-model="activeTab"
              :items="programConfig"
            />
      <div class="join-table-content">
        <ProductLink v-if="activeTab === '0'" :item="item"/>
        <Reporting v-if="activeTab === '1'" />
        <CampaignProgress v-if="activeTab === '2'" />
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from 'vue'
import { cpcCampaignsApi } from '~/server'
import { useRoute } from 'vue-router'
import LogoImage from '@/components/LogoImage.vue'
import ProductDealsColumn from "~/components/productDealsColumn.vue"
import Price from "~/components/Price.vue"
import CampaignInfoCard from './CampaignInfoCard.vue'
import ProductLink from './productLink.vue'
import Reporting from './reporting.vue'
import CampaignProgress from './campaignProgress.vue'
const route = useRoute()
const campaignId = route.params.id
const item = ref({})
const programConfig = ref([
  {
    key: '0',
    label: 'ProductLinks',
   
  },
  {
    key: '1',
    label: 'Reporting',
  },
  {
    key: '2',
    label: 'Campaign Progress',
  },
])
const activeTab = ref('0')

const publisherListLoading = ref(false)

const getCampaignDetail = async () => {
  publisherListLoading.value = true
  const { data } = await cpcCampaignsApi.getJoinedOverview({ campaignId: campaignId })
  item.value = data
}
onMounted(async () => {
  await getCampaignDetail()
})
</script>
<style lang="less" scoped>
.deal-empty {
  color: #9ca3af;
}
.artmisads-segmented-tabs{
  margin: 0!important;
}
:deep(.artmisads-segmented-tabs .tabs-list .tab-item){
  padding:16px!important;
}

.not-join {
  .join-top {
    background: var(--Brand-Primary_weaker, rgba(138, 100, 244, 0.14));
    border-radius: 12px;
    border: 2px solid rgba(138, 100, 244, 1);
    padding: 7px 12px;

    .join-top-left {
      display: flex;
      align-items: center;
      gap: 3px;

      .join-top-left-icon {
        display: flex;
        width: 20px;
        height: 20px;
        border-radius: 10px;
        box-shadow: 0 0 0 3px rgba(131, 92, 242, 0.3);
        justify-content: center;
        margin-right: 8px;

        svg {
          width: 22px;
          min-width: 22px;
          height: 22px;
          fill: rgba(131, 92, 242, 1);
          align-self: center;
          margin-left: 1px;
        }
      }

      .join-top-left-text {
        font-family: Sora;
        font-weight: 600;
        font-style: SemiBold;
        font-size: 16px;
        leading-trim: NONE;
        line-height: 24px;
        letter-spacing: 0.5px;

      }
    }

    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .join-content {
    margin-top: 12px;
  }

  .join-table {
    background: #fff;
    border: 1px solid #e8e5ed;
    border-radius: 10px;
    overflow: hidden;
    margin-top: 16px;

    .join-table-content {
      padding: 16px;
    }

    // min-width: 820px;
  }

}
</style>